<template>
	<div
	v-if="authenticated || puede_comprar_sin_login">
		
		<div
		v-if="article && !flag_activo(article.precio_pausado) && articlePriceEfectivo(article) && hasStock(article)"
		class="add-to-cart m-b-20">
			
			<notes
			:article="article"></notes>	
			

			<div class="cont-input-btn-add">
				<amount
				@addToCart="agregar_al_carrito"
				:article="article"></amount>
			
				<b-button
				v-if="!is_item_in_cart(article)"
				@click="agregar_al_carrito"
				:disabled="amount == '' || amount == 0"
				variant="outline-primary"
				class="add-to-cart__btn-add"
				v-b-tooltip.hover="{ title: 'Agregar al carrito', boundary: 'viewport' }"
				aria-label="Agregar al carrito">
					<span
					v-if="saving"
					class="spinner-border spinner-border-sm"
					role="status"
					aria-hidden="true"></span>
					<span
					v-else
					class="add-to-cart__btn-add-icons"
					aria-hidden="true">
						<i class="bi bi-cart"></i>
						<i class="bi bi-plus-lg add-to-cart__btn-add-plus"></i>
					</span>
				</b-button>
				
				<div
				v-else>
					<b-button-group
					class="add-to-cart__btn-group">
						
						<b-button
						v-b-tooltip.hover="actualizar_carrito_tooltip_config"
						@click="update_article_cart"
						variant="success"
						:class="{ 'add-to-cart__btn-actualizar--disabled': actualizar_carrito_disabled }"
						:aria-disabled="actualizar_carrito_disabled ? 'true' : 'false'"
						block>
							Actualizar
						</b-button>
						<b-button
						class="m-0"
						@click="remove_cart(article)"
						variant="outline-primary"
						>
							<i class="bi bi-cart-x" aria-hidden="true"></i>
						</b-button>
					</b-button-group>
				</div>
			</div>
		</div>

		<agotado-info
		:article="article"
		v-else></agotado-info>
	</div>
</template>
<script>
import articles from '@/mixins/articles'
import { trackear, TIPOS_EVENTO } from '@/utils/tracking'
import { articulo_fue_descartado } from '@/store/cart'
export default {
	name: 'AddToCart',
	mixins: [articles],
	props: {
		article: Object,
	},
	components: {
		Amount: () => import('@/components/article/components/data/add-to-cart/Amount'),
		AgotadoInfo: () => import('@/components/article/components/data/add-to-cart/AgotadoInfo'),
		Notes: () => import('@/components/article/components/data/add-to-cart/Notes'),
	},
	computed: {
		/**
		 * Indica si el botón "Actualizar" debe estar deshabilitado (sin cantidad válida).
		 */
		actualizar_carrito_disabled() {
			return this.amount === '' || Number(this.amount) === 0
		},
		/**
		 * Configuración del tooltip al pasar el mouse: solo activo cuando el botón está deshabilitado.
		 */
		actualizar_carrito_tooltip_config() {
			return {
				title: 'Indicá una nueva cantidad para poder actualizar el carrito.',
				disabled: !this.actualizar_carrito_disabled,
			}
		},
		amount() {
			return this.$store.state.articles.amount
		},
		notes() {
			return this.$store.state.articles.notes
		},
		selected_article_variant() {
			return this.$store.state.articles.selected_article_variant
		},
		cart() {
			return this.$store.state.cart.cart
		},
	},
	data() {
		return {
			saving: false,
		}
	},
	methods: {
		buyNow() {
			this.saveCart(true)
		},
		agregar_al_carrito() {
			// Si el precio está pausado, no se permite agregar al carrito.
			if (this.article && this.flag_activo(this.article.precio_pausado)) {
				this.$toast.warning('Este artículo no está disponible para agregar al carrito')
				return
			}
			this.saveCart()
		},
		/**
		 * Persiste la nueva cantidad del artículo en el carrito (API). No hace nada si la cantidad no es válida.
		 */
		update_article_cart() {
			// Sin `disabled` nativo: el tooltip puede recibir hover; aquí se evita el PUT inválido.
			if (this.actualizar_carrito_disabled) {
				return
			}
			let is_promocion_vinoteca = typeof this.article.is_promocion_vinoteca != 'undefined' ? true : false
			/*
			 * `is_combo` apunta al pivote correcto del lado del servidor, igual que ya hace
			 * `is_promocion_vinoteca`. Sin él, un combo iría a parar a la tabla de artículos y
			 * el id —que es de otra secuencia— actualizaría la línea equivocada.
			 */
			let is_combo = typeof this.article.is_combo != 'undefined' ? true : false

			/*
			 * 🔴 EL CARRITO DEL INVITADO NO EXISTE DEL LADO DEL SERVIDOR. `saveCart()` lo deja en
			 * memoria y no lo persiste hasta el checkout (ver su rama `else`), asi que no tiene
			 * `id`. Sin esta guarda la URL salia como `carts/update-article-amount/undefined`, la
			 * API devolvia 404 y el comprador veia dos carteles de error mientras la cantidad no
			 * cambiaba. Y es el camino NORMAL: en una tienda con `register_to_buy` apagado se
			 * compra sin registrarse.
			 */
			if (!this.authenticated || !this.cart || !this.cart.id) {
				this.actualizar_carrito_local(is_promocion_vinoteca, is_combo)
				return
			}

			this.$store.commit('auth/setMessage', 'Cargando')
			this.$store.commit('auth/setLoading', true)
			/*
			 * 🔴 Es el servidor el que recalcula acá el precio por cantidad: cambiar la cantidad
			 * puede cambiar de tramo de `article_price_ranges`, y `CartHelper` lo reevalúa al
			 * actualizar. Por eso lo que vuelve en `res.data.cart` pisa el carrito entero en vez
			 * de tocar solo el `amount` local.
			 */
			this.$api.put('carts/update-article-amount/'+this.cart.id, {
				id: this.article.id,
				is_promocion_vinoteca: is_promocion_vinoteca,
				is_combo: is_combo,
				amount: this.amount
			})
			.then(res => {
				this.$store.commit('cart/setCart', res.data.cart)
				this.$store.commit('auth/setLoading', false)
				this.$toast.success('Carrito actualizado')
			})
			.catch(err => {
				this.$store.commit('auth/setLoading', false)
				this.$toast.error(err)
			})
		},
		/**
		 * Actualiza la cantidad en el carrito local del invitado, sin pasar por la API.
		 *
		 * Espeja lo que hace la rama de invitado de `saveCart()`: el precio unitario se
		 * resuelve con `precio_por_cantidad()` porque cambiar la cantidad puede cambiar de
		 * tramo de `article_price_ranges`. Para el comprador logueado eso lo hace el servidor
		 * y vuelve en el `setCart` de la respuesta.
		 */
		actualizar_carrito_local(is_promocion_vinoteca, is_combo) {

			let amount = Number(this.amount)
			let precio_de_rango = this.precio_por_cantidad(this.article, amount, false)

			this.$store.commit('cart/update_item_amount', {
				item: {
					id: this.article.id,
					is_combo: is_combo,
					is_promocion_vinoteca: is_promocion_vinoteca,
					variant_id: this.selected_article_variant ? this.selected_article_variant.id : null,
				},
				amount: amount,
				price: precio_de_rango !== null ? precio_de_rango : this.articlePriceEfectivo(this.article, false),
				notes: this.notes,
			})

			this.$toast.success('Carrito actualizado')
		},
		saveCart(buy_now = false) {
			// Doble validación por seguridad para evitar altas al carrito por eventos manuales.
			if (this.article && this.flag_activo(this.article.precio_pausado)) {
				this.$toast.warning('Este artículo no está disponible para agregar al carrito')
				return
			}

			let amount = Number(this.amount)
			
			if (amount == ''
				|| amount <= 0) {
				this.$toast.error('Indique una cantidad')
				return
			}
			if (this.checkVariant()) {
				console.log('paso variants')
				/*
				 * 🔴 EL PRECIO DE LA LÍNEA SIGUE LA CANTIDAD. Si la cantidad que el comprador
				 * eligió cae en un rango de `article_price_ranges`, el unitario de la línea es
				 * el del rango y no el precio de lista.
				 *
				 * El pivote es OPTIMISTA: el precio que efectivamente se cobra lo resuelve
				 * `CartHelper::get_price()` del lado de la API y vuelve en el `setCart` de la
				 * respuesta. Esto es lo que ve el invitado —que no persiste el carrito hasta el
				 * checkout— y lo que suma el total local de mixins/cart.js.
				 *
				 * `precio_por_cantidad()` devuelve null cuando ningún rango aplica; ahí manda el
				 * precio de siempre. Las dos cifras están en la misma escala (recargo online y
				 * redondeo incluidos), que es justo lo que ese helper existe para garantizar.
				 */
				let precio_de_rango = this.precio_por_cantidad(this.article, amount, false)
				this.article.amount = amount
				this.article.notes = this.notes
				this.article.pivot = {
					amount: amount,
					notes: this.notes,
					variant_id: this.selected_article_variant ? this.selected_article_variant.id : null,
					price: precio_de_rango !== null ? precio_de_rango : this.articlePriceEfectivo(this.article, false)
				}
				this.$store.commit('cart/addItem', this.article)
				/*
				 * 🔴 El evento sale del llamador y NO de la mutación. cart/addItem es un
				 * TOGGLE: si el artículo ya estaba en el carrito lo saca. Emitirlo desde la
				 * mutación produciría un cart_add cuando en realidad se quitó. Acá sí se
				 * conoce la intención: este método corre desde el botón "Agregar al carrito",
				 * que solo se muestra cuando el artículo todavía no está en el carrito.
				 * Además, meter I/O adentro de una mutación de Vuex es justo lo que no se hace.
				 */
				let precio_unitario = this.article.pivot.price
				trackear(TIPOS_EVENTO.CARRITO_AGREGAR, {
					article_id: this.article.id,
					category_id: this.article.category_id,
					sub_category_id: this.article.sub_category_id,
					quantity: amount,
					/* Con precios ocultos por configuración el precio viene null: ahí no se manda monto. */
					amount: precio_unitario != null && isFinite(precio_unitario)
						? Number(precio_unitario) * amount
						: null,
				})
				if (this.authenticated) {

					this.$bvModal.hide('add-to-cart-modal')
					this.$store.commit('auth/setMessage', 'Guardando carrito')
					this.$store.commit('auth/setLoading', true)
					this.$store.dispatch('cart/save')
					.then(descartados => {

						/*
						 * 🔴 `cart/save` resuelve con los artículos que el servidor DESCARTÓ por no estar
						 * disponibles para este comprador (catalogo-por-lista-tienda). Si el que se acaba
						 * de agregar es uno de ellos, el store ya avisó ("X ya no está disponible...") y el
						 * carrito que quedó es el del servidor, sin esa línea: no hay nada que mostrar como
						 * "agregado" —ni el item, ni el popup— ni a dónde llevar con "Comprar ahora", que
						 * iría a Payment con el carrito sin este artículo (o vacío).
						 *
						 * Pasa con una lista que cambió con la ficha abierta (dos pestañas) o con listados
						 * que no se recargan (similares, favoritos). Contra una tienda-api vieja nunca
						 * llega un descartado, así que esto no corta nada.
						 */
						if (articulo_fue_descartado(descartados, this.article)) {
							this.$store.commit('auth/setLoading', false)
							return
						}

						this.$store.commit('cart/set_added_item', this.article)

						this.$store.commit('auth/setLoading', false)

						if (buy_now) {
							this.$router.push({name: 'Payment'})
						} else {
							this.$store.commit('cart/set_added_item_popup_visible', true)
						}


						this.$store.commit('articles/setAmount', '')
						this.$store.commit('articles/setNotes', '')

					})
					.catch(err => {
						this.$store.commit('auth/setLoading', false)
						console.log(err)
						this.$toast.error('Error al guardar carrito')
					})

				} else {
					// Guest checkout: carrito local sin persistir en API hasta el paso de pago.
					this.$bvModal.hide('add-to-cart-modal')
					this.$store.commit('cart/set_added_item', this.article)

					/*
					 * 🔴 Mismo criterio que la rama logueada de arriba: "Comprar ahora" tiene que
					 * llevar al pago tambien para el invitado. Antes de este arreglo `buy_now` se
					 * ignoraba aca y el boton se comportaba igual que "Agregar al carrito", sin
					 * avisar nada.
					 */
					if (buy_now) {
						this.$router.push({name: 'Payment'})
					} else {
						this.$store.commit('cart/set_added_item_popup_visible', true)
					}

					this.$store.commit('articles/setAmount', '')
					this.$store.commit('articles/setNotes', '')
				}
			}
		},
		addToCartCookie() {
			localStorage.cart = JSON.stringify(this.cart) 
		},
		checkVariant() {
			let ok = true 
			if (
				this.article.article_properties
				&& this.article.article_properties.length
			) {
				this.article.article_properties.forEach(property => {
					if (this.article.selected_article_properties[property.id] == 0) {
						this.$toast.error('Seleccione '+property.article_property_type.name)
						ok = false 
					}
				})
			}
			return ok 
		},
		checkColors() {
			if (this.article.colors.length) {
				if (this.article.pivot.color_id) {
					return true
				} else {
					this.$toast.warning('Seleccione un color')	
					return false				
				}
			}
			return true
		},
		checkSizes() {
			if (this.article.sizes.length) {
				if (this.article.size) {
					return true
				} else {
					this.$toast.warning('Seleccione un talle')	
					return false				
				}
			}
			return true
		},
		removeArticleFromCookies() {
			this.$cookies.keys().forEach(key => {
				if (key.includes('article_'+this.article.id)) {
					this.$cookies.remove(key)
				}
			})
		},
	}
}
</script>
<style scoped lang="sass">
@import '@/sass/_custom'
.add-to-cart
	display: flex 
	flex-direction: column
	border-top: 1px solid rgba(0,0,0, .1)
	padding-top: 10px

	.cont-input-btn-add
		width: 100%
		display: flex
		flex-direction: row
		align-items: stretch
		gap: 0.5rem

		::v-deep .article-amount
			flex: 1
			min-width: 0

		::v-deep .article-amount input
			width: 100% !important
			height: 100%

		.add-to-cart__btn-add
			flex-shrink: 0
			width: auto !important
			margin-left: 0
			padding: 0 0.7rem
			display: inline-flex
			align-items: center
			justify-content: center
			align-self: stretch

		.add-to-cart__btn-add-icons
			position: relative
			display: inline-flex
			align-items: center
			justify-content: center
			width: 1.35rem
			height: 1.35rem
			font-size: 1.15rem
			line-height: 1

		.add-to-cart__btn-add-plus
			position: absolute
			right: -0.35rem
			bottom: -0.2rem
			font-size: 0.62rem
			font-weight: 700
			line-height: 1
			padding: 0.05rem
			border-radius: 50%
			background: #fff

		.add-to-cart__btn-group
			flex: 1
			min-width: 0

		.add-to-cart__btn-add
			color: var(--add-to-cart-button-color) !important
			border-color: var(--add-to-cart-button-color) !important

			&:hover, &:focus, &:active
				color: #fff !important
				background-color: var(--add-to-cart-button-color) !important
				border-color: var(--add-to-cart-button-color) !important

			&.disabled, &:disabled
				color: color-mix(in srgb, var(--add-to-cart-button-color) 45%, white 55%) !important
				background-color: transparent !important
				border-color: color-mix(in srgb, var(--add-to-cart-button-color) 45%, white 55%) !important

	.add-to-cart__btn-actualizar--disabled
		opacity: 0.65
		cursor: not-allowed
		box-shadow: none
</style>